module.exports = __webpack_public_path__ + "img/Position.e4b625fa.svg";